import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: ` <div class="text-capitalize">
    <ng-container *ngIf="isManualReview; else notmanualreview">
      <ng-container *ngIf="!isNA; else namanualreview">
        {{ isYes ? 'Manual Review' : 'No' }}
      </ng-container>
      <ng-template #namanualreview>Automated</ng-template>
    </ng-container>
    <ng-template #notmanualreview>
      <ng-container *ngIf="!isNA">
        <ng-container *ngIf="!isRev; else isRevTemplate">
          <img
            *ngIf="isYes; else isno"
            class="icon-yes mr-1"
            src="/assets/images/icon-indicator-yes-check-green.svg"
            alt="Icon Yes"
          />
        </ng-container>
      </ng-container>
      <ng-template #isno>
        <img
          class="icon-no mr-1"
          src="/assets/images/icon-indicator-no-times-red.svg"
          alt="Icon No"
        />
      </ng-template>
      <ng-template #isRevTemplate>
        <img
          *ngIf="isYes; else isnorev"
          class="icon-yes mr-1"
          src="/assets/images/icon-indicator-yes-check-red.svg"
          alt="Icon Yes"
        />
      </ng-template>
      <ng-template #isnorev>
        <img
          class="icon-no mr-1"
          src="/assets/images/icon-indicator-no-times-green.svg"
          alt="Icon No"
        />
      </ng-template>
      <ng-container *ngIf="!isNA; else isna">
        {{ isYes ? 'Yes' : 'No' }}
      </ng-container>
      <ng-template #isna>N/A</ng-template>
    </ng-template>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YesnoComponent extends DataWidgetComponent implements OnInit {
  @Input()
  data: MobileAppPtiRanking;

  isYes: boolean;
  isNA: boolean = false;
  isRev: boolean = false;
  isManualReview: boolean = false;

  ngOnInit(): void {
    super.ngOnInit();
    this.isRev = this.header?.format === 'rev';
    this.isManualReview = this.header?.format === 'manual-review';
    let data = this.data[this.key];

    if (typeof data === 'string') {
      switch (data) {
        case 'T':
          this.isYes = true;
          break;
        case 'F':
          this.isYes = false;
          break;
        case 'N/A':
          this.isNA = true;
          break;
        case 'true':
          this.isYes = true;
          break;
        case 'false':
          this.isYes = false;
          break;
        default:
          this.isNA = true;
          break;
      }
    } else if (typeof data === 'boolean') {
      this.isYes = data;
    } else {
      this.isNA = true;
    }
  }
}
